import React from 'react'
import { Modal } from '../../../components/modal/Modal'
import { ModalDialogFooter } from '../../../components/modal/ModalDialogFooter'
import { TrashIcon } from '@heroicons/react/24/outline';
import { Dialog } from '@headlessui/react';
import { capitalizarPalabras } from '../../../common/upperCaseWord';

export const ModalDeleteStudentList = ({
    open,
    setOpen,
    cancelButtonRef,
    confirmAction,
    title,
    student,
    labelButonConfirm,
    loadingDeleteStudent,
    message
}) => {

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            cancelButtonRef={cancelButtonRef}
        >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-red-500 sm:mx-0 sm:h-10 sm:w-10">
                        <TrashIcon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            {title}
                        </Dialog.Title>
                        <div className="mt-2">
                            <p className="text-sm text-gray-700">
                                {message}<strong className='font-semibold'>{capitalizarPalabras(student?.name)}</strong>{` de la lista de estudiantes inscritos en el curso?`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ModalDialogFooter
                cancelButtonRef={cancelButtonRef}
                onCancel={() => setOpen(false)}
                onConfirm={confirmAction}
                confirmLabel={labelButonConfirm}
                loading={loadingDeleteStudent}
                confirmVariant="danger"
            />
        </Modal>
    )
}
